import {
  InputHTMLAttributes,
  useState,
  type ComponentType,
  type SVGProps,
} from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { siteTexts } from "../i18n/siteTexts";
import "./PasswordInput.css";

type PasswordInputProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "type"
>;

type IconLike = ComponentType<SVGProps<SVGSVGElement>>;

const EyeIcon = FiEye as unknown as IconLike;
const EyeOffIcon = FiEyeOff as unknown as IconLike;

export default function PasswordInput(props: PasswordInputProps) {
  const [isVisible, setIsVisible] = useState(false);
  const visibilityTexts = siteTexts.common.passwordVisibility;

  return (
    <span className="app-password-input">
      <input {...props} type={isVisible ? "text" : "password"} />
      <button
        type="button"
        className="app-password-input-toggle"
        aria-label={isVisible ? visibilityTexts.hide : visibilityTexts.show}
        aria-pressed={isVisible}
        title={isVisible ? visibilityTexts.hide : visibilityTexts.show}
        onClick={() => setIsVisible((current) => !current)}
      >
        {isVisible ? (
          <EyeOffIcon aria-hidden="true" />
        ) : (
          <EyeIcon aria-hidden="true" />
        )}
      </button>
    </span>
  );
}
